import styled from 'styled-components';

import { default as MaterialButton } from '@mui/material/Button';

export const StyledButton = styled(MaterialButton)`
  text-transform: ${({ nodecoration }) => (nodecoration ? 'none' : '')};
  p {
    font-size: 13px;
  }
  white-space: nowrap;
  border-radius: 6px;
  ${({ contained, theme }) =>
    contained &&
    `
  background-color: ${theme.colors.primary};
  
  &:hover {
    background-color: ${theme.colors.darkBlue2};
  }
  }`};

  color: ${({ theme, white }) => (white ? theme.colors.white : theme.colors.textBlack)};
  padding: 5px 8px;
`;
export const TableRow = styled.tr`
  height: 36px;
  cursor: pointer;
  border-bottom: 1px solid ${({ theme }) => theme.colors.lightGrey2};

  &:nth-child(odd) {
    background: ${({ theme }) => theme.colors.veryLightBlue2};
  }

  & > td {
    padding: 5px 5px 5px 10px;
    font-size: ${({ theme }) => theme.fontSize.s};
  }

  && {
    background: ${({ colored, theme }) => (colored ? theme.colors.pigeonLight : '')};
  }
  &:hover td {
    background: ${({ colored, theme }) => (colored ? theme.colors.pigeonPrimary : theme.colors.bgLightGrey)};
  }
`;

export const CenterCell = styled.td`
  text-align: left;
  text-overflow: ellipsis;
  overflow: hidden;
`;

export const LeadNumberCell = styled.td`
  text-align: left;
`;

export const PrefixPhone = styled.p`
  color: ${({ theme }) => theme.colors.grey};
  display: inline-block;
  margin: 0 5px;
`;

export const DurationCell = styled.td`
  text-align: left;
  width: 10px;
`;

export const TableHeader = styled.thead`
  position: sticky;
  top: 0;
  z-index: 2;
  tr {
    font-size: 14px;

    &:nth-child(2) {
      text-align: left;
    }
  }
  background: white;
`;

export const TableWrapper = styled.div`
  border-left: 1px solid ${({ theme }) => theme.colors.lightGrey2};
  border-top: 1px solid ${({ theme }) => theme.colors.lightGrey2};
  border-right: 1px solid ${({ theme }) => theme.colors.lightGrey2};
  border-radius: 6px;
  border-bottom: 1px solid ${({ theme }) => theme.colors.lightGrey2};
  overflow-y: auto;
  max-height: 81vh;
`;

export const Table = styled.table`
  border-collapse: collapse;
  width: 100%;
  border-spacing: 0px;
  table-layout: fixed;
`;

export const FirstRowHeader = styled.tr`
  th {
    text-align: left;
    padding: 10px 10px 10px 10px;
    width: auto;
  }

  th:first-child {
    width: 40px;
  }
`;
